<template>
  <div class="loader">
    <v-progress-circular :size="126" :width="2" color="white" indeterminate>
      <h4 class="subtitle-1 white--text">
        {{ loading.msg }}
      </h4>
    </v-progress-circular>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {},
  data: () => ({}),
  watch: {
    loading: {
      deep: true,
      handler() {
        if (!this.loading.state) {
          this.$store.commit('general/SET_LOADING', {
            state: false,
            msg: ''
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: 'general/loading'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../style/_variables.scss';
.loader {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  &-msg {
    position: fixed;
    top: 50%;
    margin-top: 6rem;
  }
}
</style>
